import { servicios } from '../properties';
import { callService } from '../tools';

export const validarLiga = (uid,time,status) => {
    return dispatch => {
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.validarUsuario',
			"secure": true,
			data: {	"uid": uid,
	                "date": time,
					"estatus": status
			}
		}).execute().then(body=>{
		     dispatch({ "type": "LOADER_HIDE"});
		     console.log(body);
		    if(body.hasOwnProperty('error')){
                 dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "error"
                  });
              }
              else {
                 dispatch({ "type": "RECUPERAR_SET_UID", 
                      "uid": body.uid
                  });
                 dispatch({ "type": "RECUPERAR_SET_ESTATUS", 
                      "estatus": body.estatus
                  });
                 if(body.estatus == "m")
                 {
                     dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "formm"
                    });
                 }
                 else if(body.estatus == "nm"){
                     dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "formnm"
                    });
                 }
              }
		}).catch(error => {
		    console.log("hubo un error");
		     dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    if(error.hasOwnProperty('message') && error.message!=""){
		        dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "expiro"
                  });
		    }
		    else{
		        dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "error"
                  });
		    }
		    
		});
    }
}

export const actualizarDatos = (datos) => {
    return dispatch => {
        console.log(datos)
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.actualizarDatos',
			"secure": true,
			data: datos
		}).execute().then(body=>{
		     dispatch({ "type": "LOADER_HIDE"});
		     console.log(body);
		    if(body.hasOwnProperty('error')){
                  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Tuvimos un error" 
                  });
              }
              else {
                 dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "contrato"
                  });
              }
		}).catch(error => {
		    console.log("hubo un error");
		     dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Hubo un error al actualizar los datos. Favor de intentar más tarde." 
                  });
		});
    }
}

export const actualizarPassword = (uid,pass) => {
    return dispatch => {
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.actualizarPassword',
			"secure": true,
			data: {	"uid": uid,
	                "pass": pass
			}
		}).execute().then(body=>{
		     dispatch({ "type": "LOADER_HIDE"});
		     console.log(body);
		    if(body.hasOwnProperty('error')){
                  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Tuvimos un error" 
                  });
              }
              else {
                 dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "exito"
                  });
              }
		}).catch(error => {
		    console.log("hubo un error");
		     dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    var mensaje = "Hubo un error al resetear el password. Favor de intentar más tarde.";
		    if(error.message.codigoError === 'eCl00026'){
		        mensaje = "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.";
		    }
		    dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : mensaje
                  });
		});
    }
}

export const aceptoContrato = (uid) => {
    return dispatch => {
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.aceptoContrato',
			"secure": true,
			data: {	"uid": uid,
					"dato": true
			}
		}).execute().then(body=>{
		     dispatch({ "type": "LOADER_HIDE"});
		     console.log(body);
		    if(body.hasOwnProperty('error')){
                  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Tuvimos un error" 
                  });
              }
              else if(body.aceptacionContratoMEClienteResponse.banExito){
                 dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "confidencialidad"
                  });
              }
		}).catch(error => {
		    console.log("hubo un error");
		     dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Hubo un error al aceptar el contrato. Favor de intentar más tarde." 
                  });
		});
    }
}

export const aceptoConfidencialidad = (uid,dato) => {
    return dispatch => {
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.aceptoConfidencialidad',
			"secure": true,
			data: {	"uid": uid,
					"dato": dato
			}
		}).execute().then(body=>{
		     dispatch({ "type": "LOADER_HIDE"});
		     console.log(body);
		    if(body.hasOwnProperty('error')){
                  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Tuvimos un error" 
                  });
              }
              else if(body.aceptacionDatosPersonalesClienteResponse.banExito){
                 dispatch({ "type": "RECUPERAR_SET_PASO", 
                      "paso": "exito"
                  });
              }
		}).catch(error => {
		    console.log("hubo un error");
		     dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Hubo un error al aceptar la confidencialidad. Favor de intentar más tarde." 
                  });
		});
    }
}


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/servicios.act.js